var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("MatchMedia", [
    _c(
      "div",
      [
        _c("Core-Title", [_c("h2", [_vm._v("Iniciar proceso A1-02")])]),
        _c("p", { staticClass: "description" }, [
          _vm._v("Solicitud de Cambio de Comercializador"),
        ]),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "steps-content" },
            [
              _c(
                "el-card",
                [
                  _vm.showForm
                    ? _c("Core-ProcessForm", {
                        attrs: { formOptions: _vm.formOptions },
                        on: { change: _vm.change, submit: _vm.onSubmit },
                      })
                    : _vm._e(),
                  !_vm.showForm
                    ? _c("ProcessesForms-CreationResult", {
                        attrs: {
                          validationErrors: _vm.errors,
                          validationResult: !_vm.errors.length,
                          loading: _vm.loading,
                        },
                        on: { onReturn: _vm.handleReturn },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }